
import { Box, Card, CardActions, CssBaseline, Grid, Typography, useTheme, Button, IconButton, Stack } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';

import AppModal from "../../../../../components/AppModal";
import InvverterFullSize from "../../../../../components/inverter/InvverterFullSize";
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure you import the autoTable plugin
import * as XLSX from "xlsx";
import logo from '../../../../../assets/img/logos/LTlogo.jpeg';
import "./DailyCurtailment.css"

import RefreshIcon from '@mui/icons-material/Refresh';
import { DailyCurtailmentApi, PrAnalysisTab3Api } from '../../../../../api/Api';
import { AppThemeContext } from '../../../../../context/AppThemeContext';

// Function to get default dates
export function getDateTimeForDashboardTab1(date = new Date()) {
    const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
    const tenDaysAgo = new Date(date);
    // tenDaysAgo.setDate(tenDaysAgo.getDate() - 0);
    tenDaysAgo.setDate(tenDaysAgo.getDate() - 9);

    const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo,
    };
}

function DailyCurtailment() {
    const now = new Date();
    const { PrimaryColor } = useContext(AppThemeContext);
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

    const { palette, spacing, shape: { borderRadius } } = useTheme()
    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(15);


    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    // Fetch data dynamically based on updated StartDate, EndDate, and ID
    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);

        const credentials = {
            LOGIN_ID: localStorage.getItem("LoginID") || "",
            PASS_KEY: localStorage.getItem("PASS_KEY") || "xyz",
            LCODE: localStorage.getItem("LCODE"),
            WEB_KEY: "xyz",
            DT1: StartDate,
            DT2: EndDate,


        };

        // console.log("data pram4 credentials:", logData);

        try {
            const res = await DailyCurtailmentApi(credentials);
            if (res?.DAILY_CURT && Array.isArray(res.DAILY_CURT)) {
                setLogData(res.DAILY_CURT);
            } else {
                setLogData([]);
            }
        } catch (err) {
            console.error("Error fetching data:", err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(logData.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Get table headers from the first item in logData (dynamically)
    const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

    // Export to Excel
    const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(logData); // Directly use the full logData
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, `Daily Curtailment`);
        XLSX.writeFile(wb, `Daily Curtailment To ${EndDate.replace(" ", "T")} Daily Curtailment.xlsx`);
    };

    // Export to PDF
    const exportToPDF = () => {
        const doc = new jsPDF();

        // Add Logo (x, y, width, height)
        const imgWidth = 30;  // Adjust width
        const imgHeight = 20; // Adjust height
        const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
        doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at top

        // Add Title or Text Below the Logo
        const title = `Daily Curtailment To ${EndDate.replace(" ", "T")}`;
        doc.setFontSize(12);  // Adjust font size
        doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Center text below logo

        // Adjust Y position for the table to start below the text
        let startY = 50;  // Push table further down below text

        doc.autoTable({
            head: [tableHeaders],
            body: logData.map((item) => tableHeaders.map((key) => item[key])),
            startY: startY,  // Start table below the logo and text
            theme: "grid",
        });

        doc.save(`Daily Curtailment To ${EndDate.replace(" ", "T")} Daily Curtailment`);
    };

    useEffect(() => {
        fetchLogData();
    }, [localStorage.getItem("LoginID")]);

    // Refresh data only when clicking "Show"
    function onRefreshData() {
        if (StartDate.length !== 0 && EndDate.length !== 0) {
            fetchLogData(); // Fetch data only after clicking the button
        } else {
            alert("Please provide valid dates");
        }
    }

    const handleStartDateChange = (value) => {
        setStartDate(value); // Update the StartDate directly
    };

    // Handle End Date change
    const handleEndDateChange = (value) => {
        setEndDate(value); // Update the EndDate directly
    };


    return (
        <>
            <Grid container style={{ padding: "0", margin: "0" }}>


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ overflow: 'hidden' }}>

                    <Stack rowGap={spacing(0)} sx={{ marginTop: '.4rem', overflow: 'hidden' }}>
                        {/* First Card */}
                        <Stack
                            component={Card}
                            p={spacing(1)}
                            sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
                        >

                            <div>

                                <div style={{
                                    marginBottom: "5px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: "16px",
                                }}>
                                    {/* Left-side title */}
                                    <div style={{ marginLeft: "7px", fontSize: "14px"  }}>
                                        Daily Curtailment
                                    </div>

                                    {/* Right-side date pickers */}
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px"
                                    }}>
                                        <label>
                                            From:&nbsp;
                                            <input
                                                type="date"
                                                value={StartDate} // Use StartDate directly
                                                onChange={(e) => handleStartDateChange(e.target.value)}
                                                style={{
                                                    padding: "2px 2px",
                                                    borderRadius: "14px",
                                                    border: "1px solid #ccc",
                                                }}
                                            />
                                        </label>
                                        <label>
                                            To:&nbsp;
                                            <input
                                                type="date"
                                                value={EndDate} // Use EndDate directly
                                                onChange={(e) => handleEndDateChange(e.target.value)}
                                                style={{
                                                    padding: "2px 2px",
                                                    borderRadius: "14px",
                                                    border: "1px solid #ccc",
                                                }}
                                            />
                                        </label>



                                        <button onClick={onRefreshData} className='button-style' >Show</button>
                                        <button onClick={exportToExcel} className='export-button' >Excel</button>
                                        <button onClick={exportToPDF} className='export-button2' >PDF</button>



                                    </div>
                                </div>

                                <div style={{ padding: "4px", marginTop: ".4rem" }}>


                                    <div className="table-responsive">
                                        <table className="table table-hover table-bordered">
                                            <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
                                                <tr>
                                                    {tableHeaders.map((header, index) => (
                                                        <th key={index} className='table-heading' style={{ color: PrimaryColor }}>{header}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? (
                                                    <tr>
                                                        <td colSpan={tableHeaders.length} className="text-center">Loading...</td>
                                                    </tr>
                                                ) : currentData.length > 0 ? (
                                                    currentData.map((item, rowIndex) => (
                                                        <tr key={rowIndex}>
                                                            {tableHeaders.map((key, index) => (
                                                                // <td key={index} className="text-center align-middle" style={tableBody}>
                                                                //     {item[key] || ""}
                                                                // </td>
                                                                <td key={index} className="text-center align-middle table-body">
                                                                    {item[key] ?? ""}
                                                                </td>

                                                            ))}
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={tableHeaders.length} className="text-center">No data available</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Pagination */}
                                    <div style={{ textAlign: "right", marginTop: "10px" }}>
                                        <button
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                            className='pagination-button'
                                            style={{ color: PrimaryColor }}
                                        >
                                            Previous
                                        </button>
                                        {[...Array(totalPages)].map((_, index) => (
                                            <button
                                                key={index}
                                                onClick={() => handlePageChange(index + 1)}
                                                style={{

                                                    backgroundColor: currentPage === index + 1 ? PrimaryColor :PrimaryColor,
                                                    color: currentPage === index + 1 ? "#fff" : "#fff",
                                                }}
                                                className='pagination-button'
                                            >
                                                {index + 1}
                                            </button>
                                        ))}
                                        <button
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            className='pagination-button'
                                            style={{ color: PrimaryColor }}

                                        >
                                            Next
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Stack>


                    </Stack>


                </Grid>

            </Grid>
        </>
    );
}

export default DailyCurtailment;
